import { render, staticRenderFns } from "./PurchasesOrderForm.vue?vue&type=template&id=c5fb5eca"
import script from "./PurchasesOrderForm.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports